import { useAuthStoreShallow } from "@features/authentication";
import { isCreatedByMeView } from "../store/stories.selectors";
import { useStoriesStoreShallow } from "../store/stories.store";

/** Whether the Stories page is showing the "Created by me" view. See isCreatedByMeView. */
export const useIsCreatedByMeView = (): boolean => {
  const currentUserId = useAuthStoreShallow((s) => s.user?.uid ?? "");
  const slice = useStoriesStoreShallow((s) => ({
    owner: s.owner,
    folderId: s.folderId,
    isFavoritesView: s.isFavoritesView,
    scopedStoryId: s.scopedStoryId,
  }));
  return isCreatedByMeView(slice, currentUserId);
};
